/*------------------------------------------------------------------
Import styles
------------------------------------------------------------------*/

import '../styles/style.scss';

/*------------------------------------------------------------------
Import scripts
------------------------------------------------------------------*/
// Import other critical components
import('scripts/components/equalizer');
document.addEventListener('DOMContentLoaded', () => {
  // Import the blocks
  import('scripts/blocks');

  // Add the src and a condition required to load the script
  window.ScriptsLoaded = ScriptLoader({
    './components/globals': true,
    './components/breakpoints': document.querySelector('[data-breakpoint]'),
    './components/forms': document.querySelector('form.userform, .js-form form'),
    './components/limit-text': document.querySelector('[data-limit]'),
    './elements/animated-headings': document.querySelector('.js-animated-headings'),
    './elements/videos': document.querySelector('[data-video]'),
    './elements/banner': document.querySelector('.js-banner-video'),
    './elements/wysiwyg-images': document.querySelector('.ss-htmleditorfield-file.image'),
    './elements/resources-search': document.querySelector('.js-resources-search'),
    './elements/featured-event': document.querySelector('.js-featured-event'),
    './elements/contact-modal': document.querySelector('.js-contact-modal form'),
    './elements/hide-show': document.querySelector('.js-hide-show'),
    './pages/blog': document.querySelector('.js-blog'),
    './pages/project-holder': document.querySelector('.js-project-holder'),
    './pages/team': document.querySelector('.js-team'),
    './pages/resources': document.querySelector('.js-resources'),
    './pages/events': document.querySelector('.js-events'),
    './pages/contact-page': document.querySelector('.js-contact-page'),
    './careers/index': document.querySelector('.xml-feed'),
    './components/css-parallax': document.querySelector('img-parallax') && CSS.supports('animation-timeline: scroll()'),
    './components/js-parallax': document.querySelector('img-parallax') && !CSS.supports('animation-timeline: scroll()')
  });
});
window.addEventListener('scripts-loaded', () => {
  console.log("%cmarmalade", "color:#0c0c0d; font-family: monospace; font-size: 20px; padding: 5px 10px; border-radius: 5px; background-color: #bbb");
  document.body.classList.add('scripts-loaded');
});